<template>
  <div @click.self="closeModal" class="modalContainer">
    <div class="modalWrapper">
      <div @click="closeModal" class="close">
        <img src="@/assets/icons/close.svg" alt="close" />
      </div>
      <h2>Remove Item</h2>
      <p>
        Are you sure that you want to delete this item?<br />
        <span class="itemName">{{ item.item_name }}</span>
      </p>
      <p class="feedback error" v-if="error.status">{{ error.message }}</p>
      <button @click="triggerRemoveItem" :disabled="buttonLoader">
        <div v-if="buttonLoader" class="loader buttonLoader"></div>
        <template v-if="!buttonLoader">REMOVE</template>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import modalMixins from '@/mixins/modalMixins.js'

export default {
  data() {
    return {
      error: {
        status: false,
        message: '',
      },
    }
  },
  props: ['item'],
  mixins: [modalMixins],
  computed: {
    ...mapState(['buttonLoader']),
  },
  methods: {
    ...mapMutations(['SET_BUTTON_LOADER', 'SET_TOASTER', 'SET_COOKIES']),
    closeModal() {
      this.$emit('closeModal')
    },
    triggerRemoveItem() {
      this.$emit('removeItemRequest')
    },
  },
}
</script>

<style src="@/assets/css/Modals/ItemModals/RemoveItemModal.css" scoped></style>
